import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Deposito } from "@/shared/types/deposito";

export interface DepositoAddRequest {
    nombre: string,
}

export async function addDeposito(request: DepositoAddRequest): Promise<Deposito> {
    await sleep(1000);
    const response = await api.post("depositos", request);
    return response.data;
}

export function useAddDepositoMutation(mutationConfig: MutationConfig<Deposito, DepositoAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addDeposito,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["depositos"] });
        },
    })
}

export interface AddDepositoMutationProps {
    mutationConfig?: MutationConfig<Deposito, DepositoAddRequest>
    children?: (mutationResult: MutationResult<Deposito, DepositoAddRequest>) => ReactNode
}

export function AddDepositoMutation({
    mutationConfig,
    children
}: AddDepositoMutationProps) {
    const mutationResult = useAddDepositoMutation(mutationConfig);
    return children && children(mutationResult);
}
